<template>
  <div class="page">
    <div class="wrap">
      <div class="card">
        <div class="Title">
          {{ modalName }}
          <span v-if="desc">（{{ desc }}）</span>
        </div>
        <div class="container">
          <div class="item" v-for="(item, idx) in list" :key="idx">
            <img
              v-if="item.status == 1"
              class="icon"
              :src="require('@/assets/download.png')"
              alt=""
              style="width:40px"
            />
            <img
              v-else
              class="icon"
              :src="require('@/assets/form/download.png')"
              alt=""
            />
            <div class="name" :title="item.uName">{{ item.uName }}</div>
            <!-- <a class="down" target="_blank" :href="getUrl(item)">下载</a> -->
            <span class="down" @click="getUrl(item)">下载</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { download, getStuStatus, updateInfoType } from "@/api/form";
import { saveLog } from "@/api/common";

export default {
  components: {},
  props: {
    modalName: {
      // 模块标题
      type: String,
    },
    desc: {
      // 模块描述
      type: String,
    },
    type: {
      // 类型id
      type: Number,
    },
  },
  data() {
    return {
      list: [],
      scode: localStorage.getItem("sCode"),
      userInfo: JSON.parse(localStorage.getItem("user")),
    };
  },
  methods: {
    getUrl(item) {
      // if (item.pFlag == 2) {
      //   window.open(
      //     `/welcome/publish/moblie/recruit/get/bkdjbDownload?sId=${this.userInfo.sid}`
      //   );
      // } else if (item.pFlag == 9) {
      //   window.open(
      //     `/welcome/publish/moblie/recruit/get/zkzDownload?sId=${this.userInfo.sid}`
      //   );
      // }
      window.open(
        `/welcome/publish/moblie/recruit/get/generateDownload?templateId=${item.templateId}&sId=${this.userInfo.sid}`
      );
      // if (item.pUrl && item.pUrl.indexOf(".rpx") != -1) {
      //   return `${item.pUrl}&scode=${this.scode}`;
      // } else {
      //   return item.pUrl;
      // }

      let userInfo = JSON.parse(localStorage.getItem("user"));
      let sid = "";
      if (userInfo) {
        sid = userInfo.sid;
      }
      updateInfoType({sId: sid, typeId: item.id, status: 1}).then(()=>{
        getStuStatus({sId: sid}).then(res=>{
          this.list.forEach((item)=>{
            res.forEach(l=>{
              if (item.id == l.typeId) {
                item.status = 1
              }
            })
          })

          let arr = []
          this.list.forEach(item=>{
            if (item.isDownloadCompleted == 1) {
              arr.push(item)
            }
          })
          let flag = arr.some(item=> item.status == 1)
          let f = false,
              fArr = [];
          this.list.forEach(item=>{
            if (item.status == 0) {
              fArr.push(item)
            }
          });
          if (fArr.length == this.list.length) {
            f = true    
          }
          if (flag || f) {
            updateInfoType({sId: sid, typeId: this.type, status: 1}).then(()=>{
              this.$emit("updateInfoType",2)
            })
          }
        })

      })

      // 保存操作记录
      let ids = [];
      let user = JSON.parse(localStorage.getItem("user"))
      ids.push(user.sid.toString());
      let params = { operation: item.uName + "下载", stuIds: ids };
      saveLog(params);
    },
    getList() {
      download({
        typeId: localStorage.getItem("TypeId"),
      }).then((res) => {
        res.forEach((item) => {
          item.status = 0;
        });
        this.list = res;

        getStuStatus({sId: this.userInfo.sid}).then(res=>{
          res.forEach(l=>{
            this.list.forEach(item=>{
              if (item.id == l.typeId) {
                item.status = 1
              }
            })
          }) 
        })
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.page {
  background-color: #f5f5f5;
}
.wrap {
}
.card {
  background-color: #ffffff;
  min-height: 448px;
  border-radius: 4px;
  padding: 0 20px;
  .Title {
    padding: 16px 0 12px;
    border-bottom: 1px solid #f5f5f5;
    font-size: 16px;
    color: #000000;
    font-weight: 600;
    span {
      font-size: 14px;
      color: #ff4747;
      font-weight: normal;
    }
  }
  .container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 24px 8px;
    .item {
      width: 164px;
      height: 164px;
      background: #fafafa;
      border-radius: 4px;
      text-align: center;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .icon {
      margin-top: 25px;
    }
    .name {
      font-size: 16px;
      color: #333333;
      margin: 8px 8px 25px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .down {
      font-size: 14px;
      color: #2a79ff;
      border: 1px solid #2a79ff;
      border-radius: 3px;
      padding: 2px 8px;
      cursor: pointer;
    }
  }
}
</style>
